import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { slices } from '~/redux/slices';
import search from '~/redux/slices/search';

import { useSidebarNav } from './SidebarNavContext';

/**
 * Handler for a plain click on a navigation link or the brand: resets the
 * search and dashboard state a freshly opened page expects, and closes the
 * mobile drawer.
 */
export function useNavLinkActivate() {
  const dispatch = useDispatch();
  const { isCollapsed, isMobile, toggleCollapsed } = useSidebarNav();

  return useCallback(() => {
    dispatch(search.actions.reset());
    dispatch(slices.dashboardV2.actions.reset());
    dispatch(slices.searchV3.actions.reset());
    if (isMobile && !isCollapsed) toggleCollapsed();
  }, [dispatch, isCollapsed, isMobile, toggleCollapsed]);
}
